function r(e) {
  return btoa(JSON.stringify(e)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function c(e) {
  const n = e.replace(/-/g, "+").replace(/_/g, "/"), t = n.padEnd(n.length + (4 - n.length % 4) % 4, "=");
  return JSON.parse(atob(t));
}
export {
  c as decodeAuthTokens,
  r as encodeAuthTokens
};
